/* ============================================================
   COLLECTION FILTERS — Filter drawer & form handling
   ============================================================ */
(function() {
  'use strict';

  const CollectionFilters = {
    init() {
      this.filterDrawer = document.querySelector('.filter-drawer');
      this.filterToggle = document.querySelector('[data-filter-toggle]');
      this.filterClose = document.querySelector('[data-filter-close]');
      this.overlay = document.querySelector('[data-overlay]');
      this.sortSelect = document.querySelector('[data-sort-select]');
      this.filterForm = document.querySelector('[data-filter-form]');

      if (!this.filterToggle) return;

      this.bindEvents();
    },

    bindEvents() {
      // Open/close filter drawer on mobile
      this.filterToggle?.addEventListener('click', () => this.openDrawer());
      this.filterClose?.addEventListener('click', () => this.closeDrawer());
      this.overlay?.addEventListener('click', () => {
        if (this.filterDrawer?.classList.contains('is-open')) {
          this.closeDrawer();
        }
      });

      // Sort change
      this.sortSelect?.addEventListener('change', () => {
        this.applyFilters();
      });

      // Filter form change
      this.filterForm?.addEventListener('change', () => {
        this.applyFilters();
      });

      // Clear all filters
      document.querySelectorAll('[data-filter-clear]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.clearFilters();
        });
      });

      // Filter group toggle
      document.querySelectorAll('.collection-filters__group-title').forEach(title => {
        title.addEventListener('click', () => {
          title.closest('.collection-filters__group')?.classList.toggle('is-collapsed');
        });
      });
    },

    openDrawer() {
      this.filterDrawer?.classList.add('is-open');
      this.overlay?.classList.add('is-visible');
      document.body.classList.add('drawer-open');
    },

    closeDrawer() {
      this.filterDrawer?.classList.remove('is-open');
      this.overlay?.classList.remove('is-visible');
      document.body.classList.remove('drawer-open');
    },

    applyFilters() {
      const url = new URL(window.location);
      const params = new URLSearchParams();

      // Sort
      if (this.sortSelect?.value) {
        params.set('sort_by', this.sortSelect.value);
      }

      // Filter checkboxes
      if (this.filterForm) {
        const formData = new FormData(this.filterForm);
        for (const [key, value] of formData.entries()) {
          params.append(key, value);
        }
      }

      url.search = params.toString();
      window.location.href = url.toString();
    },

    clearFilters() {
      const url = new URL(window.location);
      url.search = '';
      window.location.href = url.toString();
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    CollectionFilters.init();
  });
})();
